import { FC } from 'react';
import StickyBox, { StickyBoxCompProps } from 'react-sticky-box';
import { useFlags } from '../../../hooks';

export const StickyBoxFeatureFlag: FC<StickyBoxCompProps> = stickyBoxProps => {
  const featureFlags = useFlags();

  if (featureFlags.selectsPageSlidingMenus) {
    return (
      <StickyBox {...stickyBoxProps}>
        <>{stickyBoxProps.children}</>
      </StickyBox>
    );
  } else {
    return <>{stickyBoxProps.children}</>;
  }
};
